import { Component, Input } from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';

import { ColumnType } from '@cure-components/table/table.interfaces';

@Component({
  selector: 'app-table-header',
  standalone: true,
  imports: [NgIf, NgTemplateOutlet],
  templateUrl: './table-header.component.html',
})
export class TableHeaderComponent {
  @Input({ required: true }) column!: ColumnType;
}
